module.exports = __webpack_public_path__ + "img/2-3.2c8bfb2f.jpg";